import { render, staticRenderFns } from "./ChannelMenu.vue?vue&type=template&id=9cdbdc50&scoped=true"
import script from "./ChannelMenu.vue?vue&type=script&lang=js"
export * from "./ChannelMenu.vue?vue&type=script&lang=js"
import style0 from "./ChannelMenu.vue?vue&type=style&index=0&id=9cdbdc50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdbdc50",
  null
  
)

export default component.exports